import { Colors } from "@blueprintjs/core";
import * as React from "react";
import styled from "styled-components";
import { useCalendarContext } from "../CalendarContext";
import { Digits, SliceInfo } from "../utils/dates";

export interface HourBlocProps {
  height: number;
  hour: SliceInfo;
}
const GutterDiv = styled.div`
  width: 100%;
  border-top: 1px solid ${Colors.WHITE};
  display: flex;
  padding-top: 5px;
  padding-left: 10px;
  font-size: large;
  background-color: ${Colors.GRAY2};

  color: ${Colors.WHITE};
`;
export const HourBloc: React.FunctionComponent<HourBlocProps> = ({
  height,
  hour,
}) => {
  const { scrollToHour, renderHourHeader } = useCalendarContext();

  const ref = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    if (scrollToHour === hour.time.hours) {
      ref.current.scrollIntoView();
    }
  }, [hour.time.hours, scrollToHour]);

  return (
    <div ref={ref}>
      {renderHourHeader === undefined ? (
        <GutterDiv style={{ height: height }}>
          {Digits(hour.time.hours)}
        </GutterDiv>
      ) : (
        <div style={{ height: height, display: "flex", alignItems: "center" }}>
          {renderHourHeader(hour.time.hours, height)}
        </div>
      )}
    </div>
  );
};
